(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8469,65250],{

/***/ 8469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TopCampLejeuneLawyersWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/components/topcamplejeunelawyers/logo/index.tsx


function TopCampLejeuneLawyersLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "424",
        height: "50",
        fill: "none",
        viewBox: "0 0 424 50",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_190)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#272361",
                        d: "M54.225 34.74V17.173h-6.461v-3.79h17.375v3.79h-6.456V34.74h-4.458zM74.614 35.149a9.283 9.283 0 01-3.337-.555 7.508 7.508 0 01-2.564-1.661c-1.447-1.494-2.172-3.497-2.176-6.007-.003-2.51.722-4.557 2.176-6.138 1.477-1.518 3.444-2.279 5.9-2.282 2.515 0 4.489.76 5.922 2.282 1.434 1.52 2.166 3.567 2.196 6.138 0 2.524-.732 4.526-2.196 6.007-1.464 1.48-3.438 2.22-5.921 2.216zm0-3.488a3.401 3.401 0 002.862-1.202c.641-.807.96-2.019.96-3.563 0-1.545-.319-2.822-.96-3.65a3.896 3.896 0 00-5.694 0c-.63.828-.946 2.044-.95 3.65 0 1.564.319 2.756.95 3.563a3.377 3.377 0 002.832 1.202zM85.553 18.935h3.983v2.347l.277-.409a5.169 5.169 0 014.437-2.367 5.91 5.91 0 014.846 2.241c1.222 1.48 1.831 3.426 1.828 5.835 0 2.568-.609 4.641-1.828 6.22a5.806 5.806 0 01-4.846 2.347 5.336 5.336 0 01-4.437-2.216l-.06-.106v8.077h-4.2v-21.97zm7.511 12.791a3.089 3.089 0 002.585-1.267 5.78 5.78 0 00.933-3.533 5.987 5.987 0 00-.923-3.559 3.029 3.029 0 00-2.605-1.282 3.028 3.028 0 00-2.62 1.302c-.62.868-.93 2.098-.934 3.69-.075 1.205.25 2.4.924 3.402a3.093 3.093 0 002.62 1.247h.02zM125.028 27.269a8.948 8.948 0 01-2.908 5.88 9.479 9.479 0 01-6.35 2.176c-3.029 0-5.412-.997-7.148-2.993-1.737-1.995-2.62-4.71-2.65-8.142 0-3.49.883-6.26 2.65-8.31 1.767-2.049 4.149-3.075 7.148-3.078a9.592 9.592 0 016.31 2.064 8.478 8.478 0 012.948 5.553h-4.478a4.098 4.098 0 00-1.514-2.777 5.02 5.02 0 00-3.231-1.009 4.542 4.542 0 00-3.897 1.984c-.935 1.346-1.402 3.183-1.398 5.512.003 2.329.469 4.123 1.398 5.381a4.501 4.501 0 003.897 1.939 4.595 4.595 0 003.231-1.141 4.686 4.686 0 001.514-3.06l4.478.021zM131.873 35.149a4.948 4.948 0 01-3.534-1.247 4.362 4.362 0 01-1.338-3.316c0-2.945 1.574-4.646 4.72-5.104l2.757-.389a5.683 5.683 0 001.761-.47c.215-.115.383-.303.475-.53a1.45 1.45 0 00.131-.761 1.286 1.286 0 00-.666-1.055 3.875 3.875 0 00-2.07-.455 2.752 2.752 0 00-1.873.57 2.242 2.242 0 00-.691 1.672h-4.003c.171-3.702 2.527-5.553 7.067-5.553 1.953 0 3.503.419 4.654 1.247a3.982 3.982 0 011.701 3.402v8.814c-.03.512.035 1.026.192 1.514a1.183 1.183 0 00.686.646v.58h-4.497a8.376 8.376 0 01-.389-1.872 6.291 6.291 0 01-5.083 2.307zm5.017-6.244v-1.808a7.956 7.956 0 01-1.938.647l-1.514.277c-1.479.278-2.221 1.01-2.221 2.136a2.067 2.067 0 00.504 1.514 1.9 1.9 0 001.434.505 3.964 3.964 0 003.185-1.424c.181-.245.313-.523.389-.818.103-.333.157-.68.161-1.03zM144.614 34.74V18.935h3.988v2.524a4.2 4.2 0 01.686-1.186 4.79 4.79 0 014.003-1.787 4.514 4.514 0 013.448 1.423c.171.17.323.358.454.56.126.197.248.41.364.621l.505-.817a4.36 4.36 0 013.77-1.787 5.301 5.301 0 014.039 1.55c.959 1.009 1.438 2.407 1.438 4.2V34.72h-4.174v-9.258a4.768 4.768 0 00-.571-2.64 2.014 2.014 0 00-1.797-.828 2.522 2.522 0 00-2.019.797 3.373 3.373 0 00-.702 2.302v9.647h-4.154v-9.97a3.087 3.087 0 00-.606-2.11 2.42 2.42 0 00-1.893-.666 2.383 2.383 0 00-1.948.797 3.538 3.538 0 00-.657 2.302v9.647h-4.174zM171 18.935h3.982v2.347l.283-.409a5.165 5.165 0 014.432-2.367 5.913 5.913 0 014.846 2.241c1.222 1.48 1.833 3.426 1.833 5.835 0 2.568-.611 4.641-1.833 6.22a5.803 5.803 0 01-4.846 2.347 5.324 5.324 0 01-4.432-2.216l-.066-.106v8.077H171v-21.97zm7.516 12.791a3.077 3.077 0 002.615-1.246 5.75 5.75 0 00.939-3.534 5.993 5.993 0 00-.929-3.559 3.279 3.279 0 00-4.066-.951c-.453.224-.848.55-1.154.951-.626.868-.939 2.098-.939 3.69a5.464 5.464 0 00.929 3.402 3.079 3.079 0 002.605 1.247zM192.388 34.74V13.382h4.477v17.582h10.601v3.786l-15.078-.01zM216.502 35.149c-2.408 0-4.271-.737-5.553-2.216-1.282-1.48-1.964-3.594-1.964-6.35 0-2.528.673-4.502 2.02-5.922 1.346-1.42 3.197-2.138 5.552-2.155 2.4 0 4.259.732 5.578 2.196 1.319 1.464 1.947 3.538 1.883 6.224.028.318.006.638-.065.949h-10.788c.025.99.314 1.956.838 2.796.575.778 1.545 1.166 2.908 1.166a2.872 2.872 0 001.746-.54c.479-.288.827-.751.969-1.292h4.241a6.209 6.209 0 01-2.524 3.791 8.284 8.284 0 01-4.841 1.353zm3.19-9.924a4.61 4.61 0 00-.777-2.242 2.874 2.874 0 00-2.474-1.055 2.787 2.787 0 00-2.458 1.227 5.043 5.043 0 00-.752 2.07h6.461zM226.895 18.935h4.16v17.531c0 1.707-.374 2.911-1.121 3.615-.747.703-2.024 1.048-3.831 1.034h-1.146V37.78h.505c.393.04.788-.054 1.12-.268a1.399 1.399 0 00.298-1.045l.015-17.531zm-.04-5.725h4.24v3.877h-4.24V13.21zM241.333 35.149c-2.413 0-4.273-.739-5.578-2.216-1.306-1.477-1.959-3.594-1.959-6.35 0-2.528.673-4.502 2.019-5.922s3.197-2.138 5.553-2.155c2.393 0 4.255.732 5.553 2.196 1.297 1.464 1.938 3.533 1.938 6.224.03.318.008.638-.065.949h-10.793c.025.99.316 1.957.843 2.796.575.778 1.54 1.166 2.908 1.166a2.867 2.867 0 001.741-.54c.479-.288.827-.751.969-1.292h4.266a6.223 6.223 0 01-2.524 3.791 8.3 8.3 0 01-4.871 1.353zm3.185-9.924a4.6 4.6 0 00-.778-2.242 2.864 2.864 0 00-2.473-1.055 2.778 2.778 0 00-2.453 1.227 5.048 5.048 0 00-.758 2.07h6.462zM255.82 18.935v9.91c-.066.77.153 1.54.616 2.16a2.471 2.471 0 001.928.681 3.169 3.169 0 002.499-.97 4.207 4.207 0 00.858-2.866v-8.915h4.18V34.74h-3.963v-2.367c-.071.144-.15.284-.237.419-.089.141-.19.275-.303.398-1.009 1.31-2.495 1.962-4.457 1.959a5.122 5.122 0 01-3.897-1.464c-.932-.973-1.398-2.336-1.398-4.089V18.935h4.174zM269.803 34.74V18.935h3.963v2.347l.257-.419c.086-.136.177-.267.278-.399 1.009-1.302 2.504-1.955 4.482-1.958a5.15 5.15 0 013.897 1.484c.944.98 1.419 2.347 1.419 4.114V34.74h-4.155v-9.884a3.149 3.149 0 00-.626-2.17 2.47 2.47 0 00-1.938-.692 3.249 3.249 0 00-2.524.97 4.128 4.128 0 00-.873 2.841v8.935h-4.18zM294.235 35.149c-2.413 0-4.264-.739-5.553-2.216-1.288-1.477-1.941-3.594-1.958-6.35 0-2.528.673-4.502 2.019-5.922s3.197-2.138 5.553-2.155c2.399 0 4.259.732 5.578 2.196 1.319 1.464 1.945 3.538 1.878 6.224a3.09 3.09 0 01-.066.949h-10.787a5.55 5.55 0 00.837 2.796c.576.778 1.545 1.166 2.908 1.166a2.873 2.873 0 001.747-.54c.479-.288.827-.751.969-1.292h4.245a6.2 6.2 0 01-2.524 3.791 8.283 8.283 0 01-4.846 1.353zm3.191-9.924a4.6 4.6 0 00-.778-2.242 2.87 2.87 0 00-2.478-1.055 2.784 2.784 0 00-2.454 1.227 4.976 4.976 0 00-.752 2.07h6.462zM307.633 34.74V13.382h4.482v17.582h10.601v3.786l-15.083-.01zM329.273 35.149a4.948 4.948 0 01-3.534-1.247 4.375 4.375 0 01-1.337-3.316c0-2.945 1.573-4.646 4.72-5.104l2.756-.389a5.649 5.649 0 001.762-.47 1.05 1.05 0 00.474-.53 1.45 1.45 0 00.131-.761 1.287 1.287 0 00-.666-1.055 3.873 3.873 0 00-2.07-.455 2.75 2.75 0 00-1.872.57 2.245 2.245 0 00-.692 1.672h-4.003c.172-3.702 2.527-5.553 7.067-5.553 1.954 0 3.503.419 4.654 1.247a3.979 3.979 0 011.701 3.402v8.814c-.03.512.035 1.026.192 1.514a1.183 1.183 0 00.687.646v.58h-4.498a8.376 8.376 0 01-.389-1.872 6.288 6.288 0 01-5.083 2.307zm5.018-6.244v-1.808a7.978 7.978 0 01-1.939.647l-1.514.277c-1.479.278-2.221 1.01-2.221 2.136a2.067 2.067 0 00.505 1.514 1.89 1.89 0 001.433.505 3.961 3.961 0 003.185-1.424c.181-.245.313-.523.389-.818a3.67 3.67 0 00.162-1.03zM344.972 34.74l-4.583-15.805h4.432l2.524 11.61 2.367-11.61h4.18l2.327 11.65 2.585-11.65h4.194l-4.583 15.805h-4.266l-2.413-11.777-2.493 11.777h-4.271zM379.298 18.935l-5.663 16.153c-.906 2.635-1.695 4.3-2.368 4.993-.673.693-1.829 1.038-3.468 1.035l-2.019-.046v-3.337c.093.02.188.031.283.036h.535c1.105 0 1.832-.222 2.175-.666.139-.21.244-.44.313-.682.091-.293.197-.671.313-1.13l-5.901-16.366h4.609l3.468 11.716 3.337-11.716h4.351l.035.01zM388.016 35.149c-2.413 0-4.264-.739-5.553-2.216-1.289-1.477-1.941-3.594-1.958-6.35 0-2.528.673-4.502 2.019-5.922s3.197-2.138 5.553-2.155c2.399 0 4.258.732 5.578 2.196 1.319 1.464 1.945 3.538 1.878 6.224.025.318.002.638-.066.949h-10.788c.025.99.315 1.956.838 2.796.576.778 1.545 1.166 2.908 1.166a2.875 2.875 0 001.747-.54c.479-.288.826-.751.969-1.292h4.26a6.223 6.223 0 01-2.524 3.791 8.282 8.282 0 01-4.861 1.353zm3.185-9.924a4.596 4.596 0 00-.772-2.242 2.88 2.88 0 00-2.479-1.055 2.789 2.789 0 00-2.453 1.227 4.948 4.948 0 00-.752 2.07h6.456zM398.269 34.74V18.935h3.982v2.822a6.72 6.72 0 01.475-.884c.989-1.575 2.26-2.364 3.811-2.367h.944v4.245l-.591-.035h-.676c-2.514 0-3.771 1.27-3.771 3.811v8.203h-4.174v.01zM418.829 23.675a1.742 1.742 0 00-.752-1.474 3.323 3.323 0 00-2.019-.55 3.582 3.582 0 00-1.883.409 1.294 1.294 0 00-.657 1.16c0 .349.253.647.753.904.339.15.688.277 1.045.379.454.136 1.009.277 1.645.419 1.093.227 2.169.53 3.221.903a8.28 8.28 0 011.928.97c.863.721 1.292 1.787 1.292 3.21a4.486 4.486 0 01-1.898 3.746 8.182 8.182 0 01-4.952 1.398c-2.47 0-4.353-.46-5.648-1.378a4.985 4.985 0 01-2.08-4.089h4.24a2.058 2.058 0 00.959 1.711 4.505 4.505 0 002.524.616 3.763 3.763 0 001.949-.424 1.313 1.313 0 00.701-1.191 1.104 1.104 0 00-.691-.929 12.489 12.489 0 00-2.388-.752c-2.692-.576-4.479-1.2-5.361-1.873-.881-.673-1.334-1.7-1.358-3.08a4.635 4.635 0 011.747-3.79 7.067 7.067 0 014.629-1.464c2.137 0 3.867.474 5.189 1.423a4.369 4.369 0 011.979 3.746h-4.114z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M1.949 7.744L19.066 2.19l17.33 5.462v23.614s.63 4.543-5.462 8.193c-6.093 3.65-8.718 3.574-10.096 5.25l-1.363 1.68a15.173 15.173 0 00-4.73-3.78c-3.029-1.575-8.299-2.307-10.096-5.356a51.331 51.331 0 01-2.892-5.881l.212-23.635-.02.006z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#E31E2F",
                        d: "M37.017 35.401l-5.725 4.341V11.636h5.725V35.4zM8.107 39.778L2.383 35.26V11.16h5.724v28.617zM17.744 45.225l-5.725-2.68V10.686h5.725v34.538zM27.38 41.701l-5.724 2.524V10.687h5.724V41.7z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#272361",
                        d: "M35.795 7.27c-5.381-.45-14.69-3.913-16.522-4.61-1.832.697-11.14 4.155-16.522 4.61v7.571h33.064V7.269h-.02z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M14.71 9.53l.525 1.06 1.176.172-.848.828.197 1.166-1.05-.55-1.045.55.197-1.166-.848-.828 1.176-.171.52-1.06zM10.015 9.53l.525 1.06 1.171.172-.848.828.202 1.166-1.05-.55-1.05.55.202-1.166-.848-.828 1.171-.171.525-1.06zM24.104 9.53l.525 1.06 1.176.172-.848.828.197 1.166-1.05-.55-1.05.55.202-1.166-.848-.828 1.171-.171.525-1.06zM19.41 9.53l.524 1.06 1.171.172-.848.828.202 1.166-1.05-.55-1.05.55.202-1.166-.848-.828 1.171-.171.525-1.06zM28.804 9.53l.525 1.06 1.17.172-.847.828.202 1.166-1.05-.55-1.05.55.201-1.166-.853-.828 1.177-.171.525-1.06z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#272361",
                        fillRule: "evenodd",
                        d: "M18.294 41.767c1.01.797 1.388 3.952 3.533 3.029 1.575-.672 6.2-4.382 7.916-4.75 1.489-.324 4.936-1.974 5.143-3.827a53.168 53.168 0 00-4.573-3.07 30.194 30.194 0 00-.828-2.715.813.813 0 00-.303.06c.075-.512.19-1.019.344-1.514l.868.122a1.627 1.627 0 001.348-.662 5.552 5.552 0 01.368-2.17c.505-1.974.505-4.175-.651-5.861-1.514-2.282-4.407-3.322-7.158-3.281a6.179 6.179 0 00-5.765 4.31 6.453 6.453 0 00-1.474.662.459.459 0 00-.121.242.353.353 0 00.08.243c.684.54 1.466.943 2.303 1.186a.98.98 0 000 .343c.06.242.262.505.222.727-.04.222-.263.358-.424.54-.162.182-.303.505-.505.707-.202.202-.465.343-.606.6a.54.54 0 00-.04.465.626.626 0 00.262.303c.162.073.331.127.505.161v.263a1.22 1.22 0 01-.141.379c-.042.07-.076.144-.101.222a.57.57 0 00.141.323l.121.12a.63.63 0 00-.1.203.433.433 0 00.06.383c.1.091.229.141.363.142a.504.504 0 01.142.217c.04.141-.101.323-.162.505a.18.18 0 00-.1 0 2.573 2.573 0 00-.041.964c.114-.01.229-.01.343 0 .188.182.409.326.651.424l-.12.12c.355.19.748.3 1.15.324l.141-.162c.283.04.586.061.889.081.282.843.505 1.711.706 2.575-.4.19-.813.35-1.236.48 0 0 .227 1.953.232 1.953-1.636 1.605-2.524 2.655-3.382 4.619v.015z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#272361",
                        d: "M14.17 32.685v-2.564l1.948-1.54c.234.069.474.113.717.132.257 0 .182-.273.182-.273l-.752-2.463s-2.191 2.186-3.423 2.392c-1.232.207-.818-.959-.818-.959l1.09-8.818-3.83-.132.449 9.52c-.258-.398-.748-.1-.748-.1v.242s.091-.09.217.152c.127.242 0 .282 0 .282L7.461 29.92l.434 5.846a.97.97 0 00.318.57c.288.278 1.454.222 1.454.222l-.03 1.01-.334.126v1.666l.132.156.075.924 2.464-.08.176-1.46v-.949l-.459-.59v-.767l.182-.026v-.64l.177-.031c2.155-.505 5.976.747 5.976.747l.692-2.822c-1.848-.923-4.614-1.156-4.614-1.156l.066.02zm-4.962 3.58h-.631a.375.375 0 01-.334-.44V31.09l.652-.762h.504s.101 5.094.101 5.553c0 .46-.318.383-.318.383h.026zm4.613-3.898a.606.606 0 01-.615.308.475.475 0 01-.505-.55v-.757a.737.737 0 01.822-.182l.061-.267a1.044 1.044 0 00-.843 0 .54.54 0 01.586-.505c.58 0 .505.45.505.6v1.389l-.01-.036z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#FFFCF5",
                        d: "M24.442 17.143c2.7 0 5.497 1.04 7.002 3.281 1.13 1.686 1.176 3.887.65 5.86a5.552 5.552 0 00-.368 2.171 1.62 1.62 0 01-1.292.646h-.06l-.869-.12a9.848 9.848 0 00-.343 1.514.813.813 0 01.303-.06c.323.883.585 1.791.828 2.715a53.13 53.13 0 014.573 3.069c-.207 1.853-3.654 3.503-5.144 3.826-1.716.369-6.34 4.08-7.915 4.75a1.882 1.882 0 01-.722.162c-1.514 0-1.913-2.524-2.806-3.205.838-1.964 1.746-3.03 3.382-4.62l-.233-1.953c.424-.129.837-.29 1.237-.48a28.549 28.549 0 00-.706-2.574c-.303 0-.606-.04-.889-.08l-.141.16a2.8 2.8 0 01-1.151-.322l.121-.121a2.021 2.021 0 01-.651-.424 2.07 2.07 0 00-.343 0 2.573 2.573 0 01.04-.965.183.183 0 01.1 0c.061-.181.203-.363.162-.504a.505.505 0 00-.14-.217.54.54 0 01-.364-.142.435.435 0 01-.06-.383.63.63 0 01.1-.202l-.121-.121a.57.57 0 01-.142-.323c.026-.078.06-.153.101-.223a1.22 1.22 0 00.142-.378v-.263a2.278 2.278 0 01-.505-.161.627.627 0 01-.262-.303.541.541 0 01.04-.464c.141-.258.404-.4.606-.601.202-.202.282-.465.505-.707.222-.242.383-.343.424-.54.04-.197-.162-.505-.223-.727a.98.98 0 010-.343 6.755 6.755 0 01-2.302-1.187.353.353 0 01-.08-.242.46.46 0 01.12-.242 6.457 6.457 0 011.475-.661 6.178 6.178 0 015.765-4.311h.156m0-.556h-.166a6.794 6.794 0 00-3.902 1.343 6.664 6.664 0 00-2.292 3.08 6.887 6.887 0 00-1.323.63l-.06.036-.046.045a1.009 1.009 0 00-.272.505V22.383a.909.909 0 00.247.636h.025a7.348 7.348 0 002.1 1.156v.055c.032.127.078.25.136.369l.05.116-.105.11-.162.167c-.108.137-.208.28-.297.43a1.983 1.983 0 01-.167.252c-.045.045-.101.09-.162.141a1.897 1.897 0 00-.504.576 1.08 1.08 0 00-.076.929c.075.249.231.466.444.615h.06l.102.046a.203.203 0 000 .045c-.05.092-.091.188-.121.288v.136c.004.193.064.38.171.54a.974.974 0 00.172.838c.058.067.124.127.197.177l-.056.217a3.077 3.077 0 00-.055 1.176l.07.576.505-.086-.106.106.666.353c.429.225.9.356 1.383.384h.273l.121-.147h.253c.191.601.348 1.202.474 1.722-.247.104-.5.195-.757.272l-.44.142.056.454s.056.505.116.974c0 .248.056.505.076.672v.035c-1.605 1.6-2.489 2.686-3.306 4.604l-.026.505.192.146c.303.333.547.716.722 1.13.234.495.521.963.858 1.394a2.02 2.02 0 001.57.803c.324-.006.643-.077.94-.207a24.847 24.847 0 003.205-2.02c1.65-1.125 3.71-2.523 4.608-2.72a10.94 10.94 0 003.221-1.298c1.01-.636 2.206-1.65 2.347-2.897l.036-.303-.243-.192a46.945 46.945 0 00-4.442-2.988c-.267-1.01-.505-1.818-.787-2.555l-.132-.363c0-.101.046-.202.066-.298l.389.056h.141a2.206 2.206 0 001.737-.864l.12-.156v-.192a5.086 5.086 0 01.324-1.959V26.422a9.55 9.55 0 00.313-3.226 6.465 6.465 0 00-1.035-3.084 7.136 7.136 0 00-1.464-1.585 8.438 8.438 0 00-1.827-1.096 10.403 10.403 0 00-4.175-.848l.02-.01z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M9.288 18.46l3.827.132-1.09 8.839s-.35.979.55.979c.089.007.178.007.267 0 1.232-.207 3.423-2.398 3.423-2.398l.752 2.464s.075.272-.182.272a3.701 3.701 0 01-.717-.126l-1.948 1.54v2.564s2.766.227 4.613 1.15l-.691 2.823a18.92 18.92 0 00-4.796-.858 5.425 5.425 0 00-1.18.116l-.178.025v.641l-.181.025v.767l.464.591-.03.95-.177 1.463-2.463.076-.076-.924-.126-.151v-1.666l.333-.131v-1.01H9.46a2.427 2.427 0 01-1.232-.227.974.974 0 01-.318-.576l-.434-5.845 1.742-1.358s.13-.04 0-.283c-.071-.141-.137-.172-.172-.172a.066.066 0 00-.046 0v-.242a.792.792 0 01.369-.106.434.434 0 01.374.207l-.445-9.52m-.711 17.804h.67c.087 0 .279-.04.279-.389 0-.45-.101-5.553-.101-5.553H8.93l-.646.763v4.735a.374.374 0 00.333.439m4.15-5.361c.13-.053.271-.08.413-.08a.894.894 0 01.424.095l-.06.273a1.155 1.155 0 00-.298-.046.631.631 0 00-.505.222v.758a.475.475 0 00.505.55h.03a.59.59 0 00.586-.308V31.01c0-.152.065-.606-.505-.606a.54.54 0 00-.586.505M8.733 17.89l.03.6.41 8.754c-.157.03-.307.087-.445.166l-.283.172V28.45l-1.327 1.035-.233.182v.298l.434 5.85c.052.36.23.69.505.93.364.272.814.403 1.267.368v.09l-.343.132v2.251l.131.152.06.747.046.505h.53l2.459-.076h.48l.055-.475.181-1.459v-.055l.026-.95v-.196l-.126-.162-.344-.439v-.09l.162-.026v-.651c.272-.043.547-.063.823-.06 1.57.078 3.124.358 4.624.832l.57.182.141-.58.758-2.792.105-.434-.393-.197a14.64 14.64 0 00-4.311-1.156v-1.797l1.514-1.201c.193.042.389.068.586.075a.74.74 0 00.6-.282.813.813 0 00.117-.697l-.753-2.463-.272-.884-.626.626s-.54.54-1.217 1.09c-1.156.944-1.716 1.121-1.903 1.151h-.237a.698.698 0 01.035-.237V27.471l1.096-8.819.076-.605h-.611l-3.832-.132h-.6l.035-.025zm.116 13.412l.066-.08c0 1.322.075 3.776.085 4.492h-.176v-4.412h.025zm4.417.823v-.414h.035v.41l-.035.004z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#272361",
                        d: "M19 49.48c0-.03-1.842-2.807-2.579-3.594-.737-.788-1.918-1.191-3.216-1.676-.313-.121-.636-.242-.959-.373a32.168 32.168 0 01-5.441-2.58 15.867 15.867 0 01-3.74-3.195 12.317 12.317 0 01-1.95-3.18 9.212 9.212 0 01-.752-3.61V5.851l2.216-.217C6.436 5.26 13.433 2.67 18.253.586l.066-.03.984-.445 1.01.43c.025 0 2.756 1.185 6.098 2.407 4.316 1.58 7.653 2.524 9.642 2.706l2.216.217v25.396a9.198 9.198 0 01-.753 3.61 12.203 12.203 0 01-1.948 3.185 15.748 15.748 0 01-3.74 3.19 32.752 32.752 0 01-5.453 2.584c-2.236.884-4.164 1.646-4.997 2.928l-2.055 3.165-.292-.449H19zM3.15 31.307c.014.871.205 1.73.56 2.524.555 1.343 1.802 3.302 4.543 5.048a30.07 30.07 0 005.003 2.353c2.388.944 4.649 1.837 6.017 3.594 1.368-1.757 3.63-2.655 6.022-3.6a30.213 30.213 0 004.998-2.352c2.761-1.731 4.008-3.69 4.568-5.048a6.475 6.475 0 00.555-2.524V8.385c-2.256-.273-5.628-1.227-10.02-2.837a139.778 139.778 0 01-6.103-2.403C17.23 4.043 8.46 7.759 3.14 8.39v22.938l.01-.02z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M19.293.767l.853.364s2.762 1.186 6.113 2.418c4.347 1.585 7.714 2.524 9.733 2.726l1.898.186V31.57a8.864 8.864 0 01-.727 3.468 11.873 11.873 0 01-1.893 3.094 15.572 15.572 0 01-3.655 3.12 32.317 32.317 0 01-5.4 2.554c-1.16.423-2.275.96-3.328 1.605a16.37 16.37 0 00-1.847 1.429 57.73 57.73 0 01-1.747 1.479c-.106.09-1.363-1.186-1.514-1.307a11.943 11.943 0 00-2.378-1.964 31.3 31.3 0 00-3.028-1.237 32.306 32.306 0 01-5.397-2.554 15.372 15.372 0 01-3.654-3.125 11.61 11.61 0 01-1.893-3.09 8.667 8.667 0 01-.727-3.467V6.461L2.6 6.28C6.502 5.9 13.529 3.3 18.39 1.176l.06-.03.843-.379zm0 44.962c2.065-3.185 6.987-3.614 11.207-6.259 5.553-3.468 5.29-7.86 5.29-7.86V8.364C30.419 7.86 19.314 3.06 19.314 3.06c-1.828.798-11.141 4.786-16.507 5.305v23.221s-.248 4.392 5.29 7.86c4.22 2.645 9.137 3.069 11.201 6.254m0-45.73l-.282.127-.843.384-.071.03C13.306 2.605 6.355 5.184 2.539 5.558L.641 5.74l-.63.06v25.745a9.475 9.475 0 00.777 3.745 12.687 12.687 0 002.019 3.276 16.206 16.206 0 003.821 3.261 32.85 32.85 0 005.512 2.615l.97.369c1.141.377 2.209.949 3.155 1.69.595.504 1.15 1.052 1.66 1.641.364.424.677.92 1.01 1.378.086.122.172.243.262.354.091.11.147.131.273 0 .187-.232.338-.505.505-.727.166-.222.464-.59.712-.878a11.78 11.78 0 012.2-2.11 17.255 17.255 0 013.6-1.702 33.021 33.021 0 005.512-2.61 16.234 16.234 0 003.821-3.266 12.54 12.54 0 002.02-3.276 9.38 9.38 0 00.777-3.745V5.815l-.631-.065-1.898-.182c-1.964-.192-5.265-1.12-9.556-2.69C23.195 1.66 20.474.49 20.474.48L19.621.11l-.323-.141zM3.513 8.966C5.79 8.652 8.85 7.81 12.63 6.441a119.393 119.393 0 006.699-2.66c.792.333 3.18 1.328 5.976 2.352 4.226 1.545 7.512 2.489 9.794 2.812v22.66a6.24 6.24 0 01-.546 2.403 10.974 10.974 0 01-4.417 4.831 29.562 29.562 0 01-4.942 2.322c-2.281.904-4.457 1.767-5.89 3.377-1.434-1.61-3.605-2.468-5.891-3.372a29.57 29.57 0 01-4.942-2.322 10.959 10.959 0 01-4.412-4.83 6.213 6.213 0 01-.55-2.404V8.995l.004-.03z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_190",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H423.417V50H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (TopCampLejeuneLawyersLogo);

;// CONCATENATED MODULE: ./src/components/layouts/topCampLejeuneLawyersWrapper.tsx









const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function TopCampLejeuneLawyersWrapper({ children , footerBgColor  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { query  } = (0,router.useRouter)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Camp Lejeune",
                    domain: "TopCampLejeuneLawyers.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Camp Lejeune",
                    domain: "TopCampLejeuneLawyers.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                className: query.ts ? "withTS" : "withoutTS",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "bg-white relative z-50",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                            slogan: "The Best Compensation for Camp Lejeune Water Contamination Victims",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "max-w-7xl mx-auto block px-4vw lg:px-4",
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        bgColor: footerBgColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ })

}]);